import { render, staticRenderFns } from "./TaxableRebateGroupSetupGrid.vue?vue&type=template&id=755b1afe"
import script from "./TaxableRebateGroupSetupGrid.vue?vue&type=script&lang=js"
export * from "./TaxableRebateGroupSetupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports